import { render, staticRenderFns } from "./TopBg.vue?vue&type=template&id=8c3eefc6&scoped=true&"
import script from "./TopBg.vue?vue&type=script&lang=js&"
export * from "./TopBg.vue?vue&type=script&lang=js&"
import style0 from "./TopBg.vue?vue&type=style&index=0&id=8c3eefc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3eefc6",
  null
  
)

export default component.exports